import { AutogenLayoutCheckCallSchedule } from "./autogen/AutogenLayoutCheckCallSchedule";
import { Checkbox, DataSourceMode, DropdownSelectionEvent,  TableRowDisplayEvent, TableRowMode,  ChangeEvent,  DataSourceValidationEvent } from "@mcleod/components";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";
import { ModelRow } from "@mcleod/core";

const viewScheduleURL = "lme/dispatch/CheckCallSchedule?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "check_call_sched",
    screenName: "Check Call Schedule",
    navigateToUrl: viewScheduleURL
};

export class CheckCallSchedule extends AutogenLayoutCheckCallSchedule {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    /** This is an event handler for the afterDropdownSelection event of textboxSchedType. */
    textboxSchedTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.textboxEquipmentTypeId.clear();
        this.textboxCustomerId.clear();
        this.textboxCommodityId.clear();
        this.syncType();
    }

    /** This is an event handler for the onChange event of textboxSchedType. */
    textboxSchedTypeOnChange(event: ChangeEvent) {
        this.syncType()
    }

    syncType() {
        if(this.mainDataSource?.mode === DataSourceMode.SEARCH) return
        this.textboxEquipmentTypeId.visible = this.textboxCustomerId.visible = this.textboxCommodityId.visible = false;
        this.textboxEquipmentTypeId.required = this.textboxCustomerId.required = this.textboxCommodityId.required = false;

        const type = this.textboxSchedType?.selectedItem?.value;
        switch (type) {
            case "E":
                this.textboxEquipmentTypeId.visible = true;
                this.textboxEquipmentTypeId.required = true;
                break;
            case "C":
                this.textboxCustomerId.visible = true;
                this.textboxCustomerId.required = true;
                break;
            case "M":
                this.textboxCommodityId.visible = true;
                this.textboxCommodityId.required = true;
                break;
        }
    }

    /** This is an event handler for the onRowDisplay event of tableRecurring. */
    tableRecurringOnRowDisplay(event: TableRowDisplayEvent) {
        this.checkAllQuickAddCbs(event);
    }

    /** This is an event handler for the onRowDisplay event of tableFixedTimes. */
    tableFixedTimesOnRowDisplay(event: TableRowDisplayEvent) {
        this.checkAllQuickAddCbs(event);
    }

    checkAllQuickAddCbs(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.mode == TableRowMode.QUICK_ADD) {
            tableRow.findComponentsByType(Checkbox).forEach(cb => cb.checked = true);
        }
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxEquipmentTypeId. */
    textboxEquipmentTypeIdBeforeLookupModelSearch(event) {
        event.filter.applies_to = 'L';
    }

    /** This is an event handler for the onValidate event of sourceCheckCallSchedule. */
    sourceCheckCallScheduleOnValidate(event: DataSourceValidationEvent) {
        if (this.sourceCheckCallSchedule.mode === DataSourceMode.SEARCH) return;
        if (this.tableFixedTimes.data.length === 0 && this.tableRecurring.data.length === 0) {
            event.validationResults.push({
                isValid: false,
                caption: "You must enter at least one fixed time or recurring check call",
                component: this.tableFixedTimes
            });
        }
        const noDayChecked = (row: ModelRow) => {
            return !(row.getBoolean("sunday") || row.getBoolean("monday") || row.getBoolean("tuesday") || row.getBoolean("wednesday") || row.getBoolean("thursday") || row.getBoolean("friday") || row.getBoolean("saturday"));
        }
        if (this.tableFixedTimes.data.find(noDayChecked)) {
            event.validationResults.push({
                isValid: false,
                caption: "At least one day must be checked for each fixed time",
                component: this.tableFixedTimes
            });
        }
        if (this.tableRecurring.data.find(noDayChecked)) {
            event.validationResults.push({
                isValid: false,
                caption: "At least one day must be checked for each recurring check call",
                component: this.tableRecurring
            });
        }
        const endBeforeStart = (row: ModelRow) => {
            return row.get("end_time") <= row.get("start_time");
        }
        if (this.tableRecurring.data.find(endBeforeStart)) {
            event.validationResults.push({
                isValid: false,
                caption: "A recurring check call cannot have an end time before the start time",
                component: this.tableRecurring
            });
        }
    }
}
